import React from "react";

/**
 * LoaderBar
 * Renders a thin animated bar at the top of the page when loading is true.
 *
 * Props:
 * - loading: boolean (show/hide the bar)
 */
export function LoaderBar({ loading }: { loading: boolean }) {
  return loading ? (
    <div className="fixed top-0 left-0 w-full z-[100] pointer-events-none">
      <div className="h-1 bg-sky-500 animate-loader-bar" />
      <style>{`
        @keyframes loader-bar {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        .animate-loader-bar {
          width: 100%;
          animation: loader-bar 1.2s cubic-bezier(0.4,0,0.2,1) infinite;
        }
      `}</style>
    </div>
  ) : null;
}
